import React, { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { LangValue } from '../../../states/types/common'
import { setPath } from '../../../utils/url'
import CardList from '../../components/common/CardList'
import RISK_LIST from '../../constants/risk'

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()
  const location = useLocation()

  const clickContents = (url: string) => {
    history.push(`${setPath(url, language)}`)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <section className="export_page">
      <Helmet>
        <title>Qasee - リスクアセスメント</title>
      </Helmet>
      <section className="page_header">
        <h1>
          リスクアセスメント
        </h1>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-header">
            <div className="title">
              コンテンツ
            </div>
          </div>
          <div className="block-detail">
            <CardList
              clickCallback={clickContents}
              list={RISK_LIST}
            />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
